<template lang="html">
  <div>
    <v-dialog
          ref="dialog"
          v-model="dialogMenu"
          :return-value.sync="date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted"
              :label="label"
              :rules="rules"
              readonly
              v-bind="attrs"
              v-on="on"
              prepend-icon="event"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            locale="pt-br"
            scrollable
            autosave
            @input="setData()"
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="dialogMenu = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(date)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
    data: () => ({
      date: '',
      dateFormatted: '',
      dialogMenu: false
    }),
  
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      }
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
      value (val) {
        if (!val) {
          this.date = ''
          this.dateFormatted = ''
        } else {
          this.date = val
          this.dateFormatted = this.formatDate(val)
        }
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      setData () {
        this.$emit('input', this.date)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-date-dialog.vue?1b62fa8e